<ng-container *ngIf="enabled">
<!-- Floating Action Button -->
<button *ngIf="!isOpen" class="ai-fab" (click)="toggle()" title="AI Assistant">
  <svg xmlns="http://www.w3.org/2000/svg" height="28" viewBox="0 -960 960 960" width="28" fill="#fff">
    <path d="M160-360q-50 0-85-35t-35-85q0-50 35-85t85-35v-80q0-33 23.5-56.5T240-760h120q0-50 35-85t85-35q50 0 85 35t35 85h120q33 0 56.5 23.5T800-680v80q50 0 85 35t35 85q0 50-35 85t-85 35v160q0 33-23.5 56.5T720-120H240q-33 0-56.5-23.5T160-200v-160Zm200-80q25 0 42.5-17.5T420-500q0-25-17.5-42.5T360-560q-25 0-42.5 17.5T300-500q0 25 17.5 42.5T360-440Zm240 0q25 0 42.5-17.5T660-500q0-25-17.5-42.5T600-560q-25 0-42.5 17.5T540-500q0 25 17.5 42.5T600-440ZM320-280h320v-40H320v40Z"/>
  </svg>
</button>

<!-- Chat Panel -->
<div class="ai-panel" [class.open]="isOpen">

  <!-- Panel Header -->
  <div class="ai-panel-header">
    <div class="d-flex align-items-center gap-2">
      <button *ngIf="selectedCategory" class="btn btn-sm btn-link text-white p-0" (click)="backToCategories()">
        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#fff"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>
      </button>
      <span class="fw-semibold">{{ selectedCategory ? selectedCategory.name : 'AI Assistant' }}</span>
    </div>
    <div class="d-flex align-items-center gap-2">
      <span *ngIf="walletBalance !== null" class="ai-wallet-badge" [class.low]="walletBalance <= 1">
        {{ walletBalance | number:'1.2-2' }} tokens
      </span>
      <button *ngIf="selectedCategory" class="btn btn-sm btn-link text-white p-0" (click)="clearChat()" title="New Chat">
        <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" width="18" fill="#fff"><path d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z"/></svg>
      </button>
      <button class="btn btn-sm btn-link text-white p-0" (click)="close()" title="Close">
        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#fff"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
      </button>
    </div>
  </div>

  <!-- Category Selector -->
  <div *ngIf="!selectedCategory" class="ai-categories">
    <p class="text-muted small mb-3 px-1">Choose a topic to get started:</p>
    <div class="category-grid">
      <div *ngFor="let cat of categories" class="category-card" (click)="selectCategory(cat)">
        <mat-icon class="category-icon">{{ cat.icon }}</mat-icon>
        <div class="category-name">{{ cat.name }}</div>
        <div class="category-name-cn">{{ cat.name_cn }}</div>
        <div class="category-desc">{{ cat.description_cn }}</div>
      </div>
    </div>
  </div>

  <!-- Chat Area -->
  <div *ngIf="selectedCategory" class="ai-chat-area">
    <div class="ai-messages" #messageContainer>
      <div *ngFor="let msg of messages; trackBy: trackByIndex"
           class="ai-message"
           [ngClass]="{ 'msg-user': msg.role === 'user', 'msg-assistant': msg.role === 'assistant', 'msg-system': msg.role === 'system' }">
        <div class="msg-bubble">
          <div class="msg-content" [innerHTML]="msg.content | formatAiMessage"></div>
          <div *ngIf="msg.toolStatus" class="tool-status">
            <span class="spinner-border spinner-border-sm me-1"></span>
            {{ msg.toolStatus }}
          </div>
          <span *ngIf="msg.isStreaming && !msg.toolStatus && !msg.content" class="typing-indicator">
            <span></span><span></span><span></span>
          </span>
        </div>
      </div>
    </div>

    <!-- Input Area -->
    <div class="ai-input-area">
      <textarea
        [(ngModel)]="inputText"
        (keydown)="onKeydown($event)"
        placeholder="Type your message..."
        rows="1"
        [disabled]="isLoading"
        class="form-control ai-input"
      ></textarea>
      <button class="btn btn-primary btn-sm ai-send-btn" (click)="sendMessage()" [disabled]="isLoading || !inputText.trim()">
        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 -960 960 960" width="20" fill="#fff"><path d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l200 60-200 60v140Z"/></svg>
      </button>
    </div>
  </div>
</div>
</ng-container>
